module.exports = __webpack_public_path__ + "static/media/a30.66814029.jpg";